<div class="modal-header">
  <div class="modal-title normal-text pull-left">{{ 'Choose language' | translate }}</div>
</div>
<div class="modal-body">
  <div class="container">
    <div class="row justify-content-center">
        <button *ngFor="let lang of availableLangs" class="btn button-base btn-item col-3" (click)=onClick(lang)
          type="button">
          <img src="{{getFlagFilePath(lang)}}">{{ lang | translate }}
        </button>
    </div>
  </div>
</div>
